module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/Plus.e7a83303.svg";